import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Text, VStack, Divider, UnorderedList, ListItem } from "@chakra-ui/react";

const TermsPage = () => {
  const { t } = useTranslation('terms');

  return (
    <Box maxW="800px" mx="auto" p={8} bg="white" minH="100vh" paddingTop={{ base: "80px", md: "20px" }}>
      {/* Header */}
      <Box textAlign="center" mb={12} py={8} border="4px solid black">
        <Text 
          fontSize={{ base: "2xl", md: "3xl" }} 
          fontWeight="bold" 
          mb={4} 
          color="black"
          fontFamily="Abel"
        >
          {t('title')}
        </Text>
        
        <Box w="60px" h="2px" bg="black" mx="auto" mb={4} />
        
        <Text 
          fontSize="md" 
          color="black" 
          lineHeight="1.6"
          fontFamily="Source Code Pro"
        >
          {t('subtitle')}
        </Text>
      </Box>

      <VStack spacing={8} align="stretch" px={4}>
        {/* 1. General Terms */}
        <Box>
          <Text fontSize="lg" fontWeight="bold" mb={4} fontFamily="Abel">
            {t('sections.general.title')}
          </Text>
          <Text fontSize="sm" fontFamily="Source Code Pro" lineHeight="1.6" mb={4}>
            {t('sections.general.content')}
          </Text>
        </Box>

        <Divider borderColor="gray.300" />

        {/* 2. Products */}
        <Box>
          <Text fontSize="lg" fontWeight="bold" mb={4} fontFamily="Abel">
            {t('sections.products.title')}
          </Text>
          <UnorderedList spacing={2} fontFamily="Source Code Pro" fontSize="sm" lineHeight="1.6">
            {Array.isArray(t('sections.products.items', { returnObjects: true })) ? 
              (t('sections.products.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                <ListItem key={index}>{item}</ListItem>
              )) : null
            }
          </UnorderedList>
        </Box>

        <Divider borderColor="gray.300" />

        {/* 3. Orders & Payment */}
        <Box>
          <Text fontSize="lg" fontWeight="bold" mb={4} fontFamily="Abel">
            {t('sections.orders.title')}
          </Text>
          <UnorderedList spacing={2} fontFamily="Source Code Pro" fontSize="sm" lineHeight="1.6">
            {Array.isArray(t('sections.orders.items', { returnObjects: true })) ? 
              (t('sections.orders.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                <ListItem key={index}>{item}</ListItem>
              )) : null
            }
          </UnorderedList>
        </Box>

        <Divider borderColor="gray.300" />

        {/* 4. Shipping */}
        <Box>
          <Text fontSize="lg" fontWeight="bold" mb={4} fontFamily="Abel">
            {t('sections.shipping.title')}
          </Text>
          <UnorderedList spacing={2} fontFamily="Source Code Pro" fontSize="sm" lineHeight="1.6">
            {Array.isArray(t('sections.shipping.items', { returnObjects: true })) ? 
              (t('sections.shipping.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                <ListItem key={index}>{item}</ListItem>
              )) : null
            }
          </UnorderedList>
        </Box>

        <Divider borderColor="gray.300" />

        {/* 5. Returns */}
        <Box>
          <Text fontSize="lg" fontWeight="bold" mb={4} fontFamily="Abel">
            {t('sections.returns.title')}
          </Text>
          <UnorderedList spacing={2} fontFamily="Source Code Pro" fontSize="sm" lineHeight="1.6">
            {Array.isArray(t('sections.returns.items', { returnObjects: true })) ? 
              (t('sections.returns.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                <ListItem key={index}>{item}</ListItem>
              )) : null
            }
          </UnorderedList>
        </Box>

        <Divider borderColor="gray.300" />

        {/* 6. Intellectual Property */}
        <Box>
          <Text fontSize="lg" fontWeight="bold" mb={4} fontFamily="Abel">
            {t('sections.intellectual.title')}
          </Text>
          <UnorderedList spacing={2} fontFamily="Source Code Pro" fontSize="sm" lineHeight="1.6">
            {Array.isArray(t('sections.intellectual.items', { returnObjects: true })) ? 
              (t('sections.intellectual.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                <ListItem key={index}>{item}</ListItem>
              )) : null
            }
          </UnorderedList>
        </Box>

        <Divider borderColor="gray.300" />

        {/* 7. Privacy */}
        <Box>
          <Text fontSize="lg" fontWeight="bold" mb={4} fontFamily="Abel">
            {t('sections.privacy.title')}
          </Text>
          <UnorderedList spacing={2} fontFamily="Source Code Pro" fontSize="sm" lineHeight="1.6">
            {Array.isArray(t('sections.privacy.items', { returnObjects: true })) ? 
              (t('sections.privacy.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                <ListItem key={index}>{item}</ListItem>
              )) : null
            }
          </UnorderedList>
        </Box>

        <Divider borderColor="gray.300" />

        {/* 8. Liability */}
        <Box>
          <Text fontSize="lg" fontWeight="bold" mb={4} fontFamily="Abel">
            {t('sections.liability.title')}
          </Text>
          <Text fontSize="sm" fontFamily="Source Code Pro" lineHeight="1.6" mb={4}>
            {t('sections.liability.content')}
          </Text>
        </Box>

        <Divider borderColor="gray.300" />

        {/* 9. Contact */}
        <Box>
          <Text fontSize="lg" fontWeight="bold" mb={4} fontFamily="Abel">
            {t('sections.contact.title')}
          </Text>
          <VStack align="start" spacing={2} fontFamily="Source Code Pro" fontSize="sm">
            {Array.isArray(t('sections.contact.details', { returnObjects: true })) ? 
              (t('sections.contact.details', { returnObjects: true }) as string[]).map((detail: string, index: number) => (
                <Text key={index}>{detail}</Text>
              )) : null
            }
          </VStack>
        </Box>

        {/* Last Updated */}
        <Box textAlign="center" mt={12} p={6} bg="gray.50">
          <Text fontSize="xs" color="gray.600" fontFamily="Source Code Pro">
            {t('lastUpdated')}
            <br />
            {t('disclaimer')}
          </Text>
        </Box>
      </VStack>
    </Box>
  );
};

export default TermsPage;